import React, { useEffect, useRef, useState } from 'react';
import useVoice from '../../../../app/hooks/useVoice';
import MakePayment from '../../../../features/view/admin/ManagePayment/MakePayment';
import ModalComponent from '../ModalComponent/ModalComponent';
import { useSelector } from 'react-redux';

const GlobalComponent = () => {
  const { action, actionExecuted } = useVoice();
  const prevActionRef = useRef(null);
  const [modalOpenMakePayment, setModalOpenMakePayment] = useState(false);
  const selectedAccount = useSelector(state => state?.userDetailSlice?.selectedAccount);

  useEffect(() => {
    if (!action || !action.command) return;
    // Avoid re-triggering if action hasn't actually changed
    if (prevActionRef.current && prevActionRef.current.id === action.id) {
      return;
    }

    // Update stored action reference
    prevActionRef.current = action;

    if ('make payment' === action.command.toLowerCase() && !modalOpenMakePayment) {
      setModalOpenMakePayment(true);
      actionExecuted(action, false);
    }
  }, [action]);

  return (
    <>
      <ModalComponent
        openModal={modalOpenMakePayment}
        onClose={() => setModalOpenMakePayment(false)}
        modalId="makePayment"
        mainheading="Make Payment"
        modalContent={
          <MakePayment
            onClose={() => setModalOpenMakePayment(false)}
            paymentProfileId={selectedAccount?.payment_system_profile_id || selectedAccount?.crm_customer_number}
            parentAccountNumber={selectedAccount?.crm_customer_number}
            serviceAccountNumber={selectedAccount?.crm_service_account_number}
            billingAccountNumber={selectedAccount?.crm_billing_account_number}
            service_type={selectedAccount?.service_type_code}
            state={selectedAccount?.state}
          />
        }
        isLarge
      />
    </>
  );
};

export default GlobalComponent;
